import { Button } from '@blueprinthq/joy'
import { Flex, ModalBody } from '@chakra-ui/react'
import { useStoreState } from 'easy-peasy'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { EnrollmentOutcomes } from '../../../components'
import styles from '../quickenroll.module.css'

export function SubmittedView(props) {
  const { icon, setSubmitted, handleClose } = props
  const { title, subtext, message, viewProfileUrl } = useStoreState(
    state => state.quickEnroll
  )

  const history = useHistory()
  return (
    <ModalBody>
      <Flex flex={1} justify={'center'}>
        <div className={styles.successContainer}>
          <EnrollmentOutcomes
            icon={icon}
            title={title}
            subtext={subtext}
            message={message}
          />
          {icon === 'warning'
            ? null
            : <Button
                isFullWidth
                onClick={() => {
                  handleClose()
                  history.push(viewProfileUrl)
                }}
              >
                View Profile
              </Button>}
          <p
            onClick={() => setSubmitted(false)}
            className={styles.enroll_another_link}
            tabIndex="0"
            role="button"
            onKeyDown={e => {
              const key = e.which
              if (key === 13 || key === 32) {
                setSubmitted(false)
              }
            }}
          >
            Enroll another client
          </p>
        </div>
      </Flex>
    </ModalBody>
  )
}
